module.exports = __webpack_public_path__ + "static/media/logo-red.af715a8d.svg";